import React from "react";
import IuManagementPageBase from "../../SHARED/components/IuManagementPageBase";
import {
  buildAdminAccountManagementLinks,
  IU_MANAGEMENT_PAGE_TITLE,
} from "../../SHARED/iuManagementPageConfig";
import { isDuplicateAccountsMergeUiEnabled } from "../../../globals/utils/duplicateAccountsMergeFeature";

const AdminAccountManagement = () => (
  <IuManagementPageBase
    title={IU_MANAGEMENT_PAGE_TITLE.account}
    links={buildAdminAccountManagementLinks(isDuplicateAccountsMergeUiEnabled())}
  />
);

export default AdminAccountManagement;
